
export const type= 'HANDLE-MODAL'
const   HandleModal = (open)=>({
    type,
    open
})
export default HandleModal